export const API_TIMEOUT_MS = 15_000;
export const CSRF_COOKIE = 'csrf_token';
export const CSRF_HEADER = 'X-CSRF-Token';
export const REQUEST_ID_HEADER = 'X-Request-ID';
export const MUTATING_METHODS = new Set(['post', 'put', 'patch', 'delete']);
export const AUTH_PATH_PATTERN = /(^|\/)auth\//;
export const FORBIDDEN_NOTICE_DEBOUNCE_MS = 2_000;

export const LIST_LIMIT_DEFAULT = 25;
export const LIST_LIMIT_MAX = 100;

export const DATA_SOURCE = Object.freeze({ DEMO: 'demo', API: 'api' });
